import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "@/translations/en-US.json";
import translationMS from "@/translations/ms-MY.json";

declare module "i18next" {
    interface CustomTypeOptions {
        defaultNS: "translation";
        resources: {
            translation: typeof translationEN;
        };
    }
}

const resources: Record<string, { translation: string | object }> = {
    "en-US": {
        translation: translationEN,
    },
    "ms-MY": {
        translation: translationMS,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem("lang") === undefined ? "en-US" : localStorage.getItem("lang") ?? "en-US", // default language to en-US
    // keySeparator: false,
    fallbackLng: "en-US", // fallback language if translation is missing
    debug: true,
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
